function run() {
  const head = document.getElementsByTagName("HEAD")[0];
  const link = document.createElement("link");

  link.rel = "stylesheet";
  link.href = window.env.ASSETS;

  head.prepend(link);
}

export default { run };
